import { ChangePasswordType } from "../../types/Auth";
import { patch } from "../../utils/axios-config";
import { AUTH_CHANGE_PASSWORD } from "../../utils/constants";

export const changePassword = async (data: ChangePasswordType) => await patch<ChangePasswordType, string>(AUTH_CHANGE_PASSWORD, data);